import {IBetWayWinData, IBetWinData, ITheRaveData, ITheRaveGameData} from "./ITheRaveData";
import {TheRaveGameConfig} from "../../TheRaveGameConfig";
import {IWinRatioConfig} from "../../../core/config/WinRatio";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TheRave} from "../../TheRave";
import {Logger} from "@nolimitcity/slot-launcher/bin/utils/Logger";

export class TheRaveDataParser {

    constructor() {
    }

    // Game Data:

    public parseReels(rawData: ITheRaveData): string[][] {
        let extraReels: string[][] = [["X"], ["X"], ["X"], ["X"], ["X"]];
        if (rawData.scatterEnhancers) {
            rawData.scatterEnhancers.forEach((scatterEnhancer: string[], i: number) => {
                    extraReels[parseInt(scatterEnhancer[0])][0] = scatterEnhancer[2];
            });
        }
        const newReels: string[][] = rawData.reels.concat(extraReels);
        return newReels;
    }

    public parseBetWins(rawData: ITheRaveGameData): IBetWayWinData[] {
        rawData.betWayWins!.forEach((wins: IBetWayWinData) => {
            const reelWinPositions: number[][] = [];
            rawData.evaluatedArea.forEach((reel: string[], i: number) => {
                if (i < wins.length) {
                    reel.forEach((symbol: string, j: number) => {
                        if (symbol === wins.symbol || symbol === "W" || symbol === "XS") {
                            reelWinPositions.push([i, j]);
                        }
                    });
                }
            });
            wins.reelWinPositions = reelWinPositions;
        });
        return rawData.betWayWins!;
    }

    public parsePotentialWin(rawData: ITheRaveGameData): boolean {
        const arr1 = rawData.reels[0].slice(1,4);
        const arr2 = rawData.reels[1].slice(1,4);
        //console.log("Arr1", arr1);
        //console.log("Arr2", arr2);
        const intersection = arr1.filter(element => arr2.includes(element))
        //console.log("INTERSECTION: " + intersection);

        if(intersection.length > 0) {
            return true;
        }
        if(arr1.indexOf("W") > -1 || arr1.indexOf("XW") > -1) {
            return true;
        }

        if(arr2.indexOf("W") > -1 || arr2.indexOf("XW") > -1) {
            return true;
        }

        return false;
    }

    public parseBetWinPositions(betWayWins: IBetWinData[]): boolean[][] {
        let winPos: boolean[][] = ArrayHelper.initArrayWithValues(5, () => ArrayHelper.initArrayWithValues(4, () => false));
        if(!betWayWins){
            return winPos;
        }
        (<IBetWayWinData[]>betWayWins!).forEach((wins: IBetWayWinData) => {
            wins.reelWinPositions.forEach((reelWinPositions: number[]) => {
                winPos[reelWinPositions[0]][reelWinPositions[1]] = true;
            });
        });
        //console.log(winPos);
        return winPos;
    }

    public parsePotentialWinPos(rawData: ITheRaveGameData): boolean[][] {
        let potentialWinPos: boolean[][] = ArrayHelper.initArrayWithValues(5, () => ArrayHelper.initArrayWithValues(3, () => false));
        if (!rawData.betWayWins) {
            return potentialWinPos;
        }
        const reels: string[][] = rawData.reels.concat();
        for (let win of rawData.betWayWins) {
            let matchingSymbols = [win.symbol, "W"];
            let skipToNextLine = false, i: number = 0;
            for (i = 0; i < 5; i++) {
                const reel = reels[i].slice(1, 4);
                skipToNextLine = ((reel.filter(element => matchingSymbols.includes(element))).length < 1);
                if (skipToNextLine) break;
            }
            if (i > 2) {
                win.reelWinPositions.forEach((pos: number[]) => {
                    potentialWinPos[pos[0]][pos[1]] = (matchingSymbols.includes(reels[pos[0]][pos[1] + 1]));
                });
            }
        }
        Logger.logDev("potentialWinPos: "+ potentialWinPos);
        return potentialWinPos;
    }

    public parseSingleWin(betWins: IBetWinData[]): number {
        if (betWins && betWins.length > 0) {
            return betWins.reduce((a, b: IBetWinData) => {
                return a + b.multipliedAmount;
            }, 0);
        }

        return 0;
    }

    public parseNearWinReels(scatterPositions: number[]): boolean[] {
        let scatterNum:number = 0, hasNearwin:boolean = false;
        const result = [];

        for(let i:number = 0; i<scatterPositions.length;i++){
            hasNearwin = scatterNum>=TheRave.model.startNearWinAtScatterCount;
            scatterNum += scatterPositions[i]>-1?1:0;
            result.push(hasNearwin);
        }

        return result;
    }

    public parseWinRatio(winRatio: number): IWinRatioConfig | null {
        let ratioConfigs: IWinRatioConfig[] = TheRaveGameConfig.WIN_RATIOS;

        let ratioConfig;
        for (let i: number = ratioConfigs.length - 1; i >= 0; i--) {
            const config = ratioConfigs[i];
            if (winRatio >= config.ratio) {
                ratioConfig = config;
                break;
            }
        }

        if (ratioConfig) {
            return {
                ratio: winRatio,
                name: ratioConfig.name,
                duration: ratioConfig.duration,
                bigWinLevel: ratioConfig.bigWinLevel,
                normalWinLevel: ratioConfig.normalWinLevel,
            }
        }
        return null;
    }
}